var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "80%",
    height: "80%",
    x: "10%",
    y: "10%",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66667 0C0.746192 0 0 0.746192 0 1.66667V18.3333C0 19.2538 0.746192 20 1.66667 20H18.3333C19.2538 20 20 19.2538 20 18.3333V1.66667C20 0.746192 19.2538 0 18.3333 0H1.66667ZM15.9114 4.16629H13.8676L10.4599 8.01376L7.54974 4.16629H3.33337L8.35392 10.7416L3.59995 16.2063H5.64371L9.33137 11.9945L12.5525 16.2063H16.6667L11.424 9.27551L15.9114 4.16629ZM14.2853 15.0067H13.1523L5.73701 5.32142H6.95438L14.2853 15.0067Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.c8f7638114a4edea63bc062fc28b6dfc.svg";
export { ForwardRef as ReactComponent };